import React, { useEffect } from 'react'
import Layout from './Layout';
import Head from 'next/head';
import TechnologyAnalysis from '@/app/Components/TechnologyAnalysis/TechnologyAnalysis';


const TechnologyAnalysisPage = () => {

  useEffect(() => {
    document.body.style.margin = '0';
  }, []);

  return (
    <div>
      <Head>

        <title>Ideapoke AI-Powered Technology Analysis</title>
        <link rel="shortcut icon" href="/ipimages/enterprise/images/ufoant.ico" />
        <link rel="icon" type="image/ico" href="/ipimages/enterprise/images/ufoant.ico" />
        <link rel="apple-touch-icon" href="/ipimages/enterprise/images/ufoant.ico" />

        <meta
          content="Explore emerging technologies and the startup landscape with Ideapoke's AI. Stay informed with detailed tech analysis and company profiles."
          name="description"

        />
        <meta
          content="Ideapoke AI-Powered Technology Analysis"
          property="og:title"
        />
        <meta
          content="Explore emerging technologies and the startup landscape with Ideapoke's AI. Stay informed with detailed tech analysis and company profiles."
          property="og:description"
        />
        <meta
          content="emerging technologies, startup landscape, detailed tech analysis, company profiles"
          property="og:keywords"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="og:image"
        />
        <meta
          content="Ideapoke AI-Powered Technology Analysis"
          property="twitter:title"
        />
        <meta
          content="Explore emerging technologies and the startup landscape with Ideapoke's AI. Stay informed with detailed tech analysis and company profiles."
          property="twitter:description"
        />
        <meta
          content="https://www.ideapoke.com/ipimages/enterprise/images/Ideapoke.jpg"
          property="twitter:image"
        />
        <meta
          content="emerging technologies, startup landscape, detailed tech analysis, company profiles"
          property="og:keywords"
        />

        <meta property="og:type" content="website" />
        <meta content="summary_large_image" name="twitter:card" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
      </Head>
      <Layout>
        <TechnologyAnalysis />
      </Layout>
    </div>
  )
}

export default TechnologyAnalysisPage;
